// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.approval-upload__input {
  display: none !important;
}

.approval-upload__hint {
  color: #667085;
  font-size: 0.85rem;
  margin-bottom: 0.875rem;
}

.approval-upload__dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  width: 100%;
  padding: 1.5rem 1rem;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}

.approval-upload__dropzone:hover,
.approval-upload__dropzone:focus-visible {
  background: #f1f5f9;
  border-color: #94a3b8;
  outline: none;
}

.approval-upload__dropzone--active {
  background: #eef2f6;
  border-color: #1d2939;
}

.approval-upload__dropzone-icon {
  color: #475467;
  font-size: 24px;
  display: flex;
}

.approval-upload__dropzone-title {
  color: #1d2939;
  font-weight: 600;
  font-size: 0.9rem;
}

.approval-upload__dropzone-meta {
  color: #667085;
  font-size: 0.72rem;
  text-align: center;
}

.approval-upload__file {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 0.625rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 0.625rem 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.approval-upload__file-icon {
  color: #667085;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.approval-upload__file-name {
  color: #1d2939;
  font-weight: 500;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-upload__file-meta {
  color: #667085;
  font-size: 0.72rem;
}

.approval-upload__remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #667085;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.approval-upload__remove:hover {
  background: #fee4e2;
  color: #b42318;
}

.approval-upload__error {
  color: #b42318;
  font-size: 0.78rem;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/ApprovalAttachmentModal/attachmentUpload.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf;;2BAEyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".approval-upload__input {\n  display: none !important;\n}\n\n.approval-upload__hint {\n  color: #667085;\n  font-size: 0.85rem;\n  margin-bottom: 0.875rem;\n}\n\n.approval-upload__dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.375rem;\n  width: 100%;\n  padding: 1.5rem 1rem;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.approval-upload__dropzone:hover,\n.approval-upload__dropzone:focus-visible {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n  outline: none;\n}\n\n.approval-upload__dropzone--active {\n  background: #eef2f6;\n  border-color: #1d2939;\n}\n\n.approval-upload__dropzone-icon {\n  color: #475467;\n  font-size: 24px;\n  display: flex;\n}\n\n.approval-upload__dropzone-title {\n  color: #1d2939;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.approval-upload__dropzone-meta {\n  color: #667085;\n  font-size: 0.72rem;\n  text-align: center;\n}\n\n.approval-upload__file {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) 32px;\n  align-items: center;\n  gap: 0.625rem;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 0.625rem 0.75rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.approval-upload__file-icon {\n  color: #667085;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.approval-upload__file-name {\n  color: #1d2939;\n  font-weight: 500;\n  font-size: 0.85rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.approval-upload__file-meta {\n  color: #667085;\n  font-size: 0.72rem;\n}\n\n.approval-upload__remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #667085;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.approval-upload__remove:hover {\n  background: #fee4e2;\n  color: #b42318;\n}\n\n.approval-upload__error {\n  color: #b42318;\n  font-size: 0.78rem;\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
